import { BaseContainerModel } from "../../../base-container.model";
import {
  bl_alg_cc_template_message_ext_RowClass,
  bl_alg_cc_template_message_hdr_RowClass,
  bl_alg_cc_template_message_hdr_RowInterface,
  bl_alg_cc_template_message_lines_RowClass
} from "../../../../dbschema";

export class TemplateMessageContainerModel extends BaseContainerModel {
  bl_alg_cc_template_message_hdr: bl_alg_cc_template_message_hdr_RowInterface = new bl_alg_cc_template_message_hdr_RowClass();
  bl_alg_cc_template_message_exts: bl_alg_cc_template_message_ext_RowClass[] = [];
  bl_alg_cc_template_message_lines: bl_alg_cc_template_message_lines_RowClass[] = []
}
